import React, { useState } from 'react';
import Select, { SelectValue } from '../../../Select/Select';
import { useEffectAsync } from '../../../../../../helpers';
import useApiClient from '../../../../../../Hooks/useApiClient';
import apiClient from '../../../../../../Services/ApiClient';
import useLoading from '../../../../../Base/Hook/useLoading';

interface Props {
	partnerId: number;
	onChange?: (value: SelectValue) => void;
}

const PartnerWorkplaceSelect: React.FC<Props> = ({ partnerId, onChange }) => {
	const [options, setOptions] = useState<SelectValue[]>([]);
	const { isLoading, setIsLoading, RenderLoading } = useLoading(true);
	const { displayError } = useApiClient();

	useEffectAsync(async () => {
		setIsLoading(true);
		const temp: SelectValue[] = [];

		try {
			const response = await apiClient.get(`/workplaces/partner/${partnerId}`);
			if (response.status === 200) {
				response.data.forEach((item: { id: string; name: string }) => {
					temp.push({ value: item.id, label: item.name });
				});
			}
		} catch (e) {
			displayError(e);
		}

		setOptions(temp);
		setIsLoading(false);
	}, []);

	if (isLoading) {
		return <RenderLoading />;
	}

	return (
		<Select options={options} onChange={onChange} displayErrorMessage={false} />
	);
};

export default PartnerWorkplaceSelect;
